import React from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import GradientCard from './gradient-card';
import TestsCountCard from './tests-count-card';

const Statistics = () => {
  const t = useTranslations();

  return (
    <div className="rounded-2xl bg-white p-5 order-2 lg:order-1">
      <div className="flex items-center gap-1.5 font-semibold">
        {t('barchasi')}
        <div className="rounded-lg bg-purple-600 px-2.5 py-1 text-xs text-white">{t('cheksiz')}</div>
      </div>
      <div className="mt-3 grid grid-cols-2 gap-3">
        <TestsCountCard testType="DTM" testsCount={2849} />
        <TestsCountCard testType={t('nav.mavzuli_test')} testsCount={649} />
        <TestsCountCard testType="Avto" testsCount={120} />
        <TestsCountCard testType={t("milliy_sertifikat")} testsCount={60} />
      </div>
      <div className="!my-3 bg-gray-100 p-[0.5px]" />
      <div className="mt-3 grid grid-cols-2 gap-3">
        <GradientCard
          title={t('xatolar_ustida_ishlash')}
          background="bg-purple-50"
          content={
            <>
              <div className="absolute -right-1 -top-1 size-6 rounded-full bg-purple-600 blur-xl" />
              <div className="-bottom-15 -right-15 w-55 h-55 absolute">
                <Image alt="LOOP" fill title="Imtihonlarni tekshirish imkoniyati" src="/images/loop.webp" />
              </div>
            </>
          }
        />
        <GradientCard
          title={t('kurslarga_chegirma')}
          background="bg-yellow-50"
          content={
            <div className="absolute -bottom-2 md:-bottom-9 -right-8 md:-right-6 flex items-end md:text-[7.403rem] text-8xl font-bold text-[#E9A500] drop-shadow-[-4.23px_7.05px_0_#5C2B00]">
              10 <span className="mb-3 text-[5.288rem]">%</span>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default Statistics;
